<script setup lang="ts">
import { computed, inject, Ref } from 'vue';
import { useScroll } from '@/hooks/useScroll';
import { useRoute } from 'vue-router';

const globalScrollTop = inject<Ref<number>>('globalScrollTop');
const { scrollToTop } = useScroll();
const route = useRoute();
const pageNotShow = ['/home', '/usecase'];

const show = computed(
  () => !pageNotShow.includes(route.path) && globalScrollTop && globalScrollTop.value > 500,
);
</script>

<template>
  <div
    v-show="show"
    class="pin-to-top flex justify-center items-center cursor-pointer w-[0.87rem] h-[0.87rem] fixed right-[.32rem] bottom-[1.3rem] rounded-[50%]"
    @click="scrollToTop"
  ></div>
</template>

<style lang="scss" scoped>
.pin-to-top {
  background: url('https://dts.bmw.com.cn/__statics/eraImages/Home/pin-to-top.png');
  background-size: cover;
}
</style>
